module.exports = __webpack_public_path__ + "static/img/literacy1.4a7336d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/partners/literacy1.jpg
// module id = LGYe
// module chunks = 1